import { principalService } from '../services';
import { AssetName, Asset } from '../helpers';

export const usePrincipal = () => {
  const fetchPrincipals = async (data, setData, key = 'owner_principal_id', abortFetch) => {
    try {
      if (!data) {
        return;
      }
      let uniquePrincipalIds;
      if (Array.isArray(data)) {
        uniquePrincipalIds = [...new Set(data.map(x => x[key]))];
      } else {
        uniquePrincipalIds = [data[key]];
      }

      const principals = await principalService
        .getById(uniquePrincipalIds, abortFetch)
        .then(res => {
          return (res && res.principals) || [];
        })
        .catch(e => {
          throw e;
        });

      let principalMap = {};
      principals.forEach(x => {
        principalMap[x.principal_id.toString()] = x;
      });

      setData &&
        setData(prev => {
          if (Array.isArray(prev)) {
            return prev.map(x => {
              const item = x[key] === null ? undefined : principalMap[x[key].toString()];
              return {
                ...item,
                ...x,
                principal_url: item?.principal_type
                  ? `${item.principal_type + 's'}/${item.object_id}`
                  : undefined,
                principal_type_name:
                  item?.principal_type === Asset.UserGroup
                    ? AssetName[item.principal_type]
                    : undefined,
              };
            });
          } else {
            const item = prev[key] === null ? undefined : principalMap[prev[key].toString()];
            return {
              ...item,
              ...prev,
              principal_url: `${
                item?.principal_type ? item.principal_type + 's' : undefined
              }/${item.object_id}`,
              principal_type_name:
                item?.principal_type === Asset.UserGroup
                  ? AssetName[item.principal_type]
                  : undefined,
            };
          }
        });
      return principals;
    } catch (e) {
      throw e;
    }
  };

  return { fetchPrincipals };
};
